import React from "react";
import { useHistory } from "react-router-dom";

import styles from "./ShowGroupCube.module.css";
import captainBadge from "./../../graphics//elements/captainBadge@3x.png";



function ShowGroupCube(props) {
  let history = useHistory();
  const { groupObj } = props;

  const handleClick = (groupObj) => {
    history.push(`/leagues/${groupObj.league}/teams/${groupObj.id}`);
  };

  return (
    <div
      className={styles.groupCube}
      onClick={() => {
        handleClick(groupObj);
      }}
    >
      <img
        src={
          groupObj.image != null
            ? groupObj.image
            : "https://images.unsplash.com/photo-1527871252447-4ce32da643c6?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=2389&q=80"
        }
        alt=""
      />
      <h2>{groupObj.name}</h2>
      <p>
        <img src={captainBadge} alt="קפטן הקבוצה" />
        {groupObj.captain_name == null ? "אין קפטן" : groupObj.captain_name}
      </p>
    </div>
  );
}



export default ShowGroupCube;
